const NS = 'mmfsTileBlock';
const CLS = 'mmfsTileBlock';

import { handleTruncate } from '../../../../global/js/truncate';

export class MmfsTileBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.limit = 150; // reserved limit (characters)
		this.$summary = this.$element.find(`.${CLS}-summary`);
		this.summaryHtml = this.$summary.html();
		this.summaryText = this.$summary.text(); // for comparison without the extra characters from html tags
		this.originalHtml = this.summaryHtml;
		this.moduleId = this.$element.data(`moduleId`);
		this.$downloadBtn = this.$element.find(`.btn-download`);
		this.$downloadBtn.on('click', () => {
			window.open("/mmfs-download-modules-page?moduleId="+this.moduleId);
		});
		// handle truncate (read more / read less)
		handleTruncate(this);
	}
}
